import { render, staticRenderFns } from "./VipPop.vue?vue&type=template&id=9665f60e&scoped=true"
import script from "./VipPop.vue?vue&type=script&lang=js"
export * from "./VipPop.vue?vue&type=script&lang=js"
import style0 from "./VipPop.vue?vue&type=style&index=0&id=9665f60e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9665f60e",
  null
  
)

export default component.exports